import React, { useState } from "react";
import { connect } from "react-redux";  
import { Drawer, Form, Input, InputNumber, Button, Select, message } from "antd";
import { createDamageStock } from "../../../actions/Inventory/damageStockAction";
import { getProductSearchResultforsales } from "../../../actions/productDetails";

const { Option } = Select;

const CreateDamageStock = ({ open, onClose, reload, getProductSearchResultforsales }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [products, setProducts] = useState([]);

  const handleSearchProduct = async (value) => {
    if (value.length < 2) return;
    try {
      const res = await getProductSearchResultforsales(value, "", 1, 20);
      console.log("API Response:", res); // Debug log
      setProducts(res.results || []);
    } catch (error) {
      console.error("Search error:", error);
      message.error("Failed to load product list");
    }
  };

  const onFinish = async (values) => {
    setSaving(true);
    try {
      await createDamageStock(values);
      message.success("Damage stock created successfully");
      form.resetFields();
      onClose();
      reload();
    } catch (err) {
      message.error(err.non_field_errors || "Error creating damage stock");
    }
    setSaving(false);
  };

  console.log(products)

  return (
    <Drawer
      title="Add Damage Stock"
      width="50%"
      open={open}
      onClose={onClose}
      destroyOnClose
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          name="product_location"
          label="Product Location"
          rules={[{ required: true, message: "Please select a product" }]}
        >
          <Select
            showSearch
            placeholder="Search by barcode, batch no, or product name"
            onSearch={handleSearchProduct}
            filterOption={false}
            notFoundContent={products.length === 0 ? "No products found" : null}
          >
            {products.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.ProductDetails.title || "N/A"} - {item.Warehouse_name || "N/A"}
                {item.barcode && ` (Barcode: ${item.barcode})`}
                {item.batch_no && ` (Batch: ${item.batch_no})`}
                {` - Stock: ${item.quantity}`}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="quantity"
          label="Quantity"
          rules={[{ required: true, message: "Please input quantity" }]}
        >
          <InputNumber min={1} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item name="remarks" label="Remarks">
          <Input.TextArea rows={3} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={saving} block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getProductSearchResultforsales,
})(CreateDamageStock);